export default function utils(){
    
}

export function getQueryParam(param:String):String {
    var rx = new RegExp("[?&]" + param + "=([^&]+).*$");
    var returnVal = window.location.search.match(rx);
    return returnVal === null ? "" : decodeURIComponent(returnVal[1].replace(/\+/g, " "));
}

export function random(min: number, max: number):number {
    return Math.floor(Math.random() * (max - min + 1) + min);
}


export function getAllUrlParams(url:any): {[id: string]: any} {
    var params:any = {};
    var parser = document.createElement("a");
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var valeur = decodeURIComponent(pair[1]);
        params[pair[0]] =valeur;
    }
    return params;
}

export function arrondirMultipleDe5(nombre:number): number {
    return Math.round(nombre/5)*5;
}

export function shuffleArray(arrayToShuffle:Array<any>) {

    var currentIndex = arrayToShuffle.length;
    var temporaryValue;
    var randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = arrayToShuffle[currentIndex];
        arrayToShuffle[currentIndex] = arrayToShuffle[randomIndex];
        arrayToShuffle[randomIndex] = temporaryValue;
    }

    return arrayToShuffle;
    
}
